import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ShieldCheck } from 'lucide-react';
type OfferId = 'kit' | 'megapack';
interface Offer {
  id: OfferId;
  name: string;
  meta: string;
  price: string;
  summary: string;
  checkoutUrl: string;
  highlight?: boolean;
}
const offers: Offer[] = [{
  id: 'kit',
  name: 'Kit Protocolo Dermatológico',
  meta: '4 tomos + 3 bonos · 70 páginas',
  price: '$19.990',
  summary: 'Adherencia, Alarma Post-Procedimiento, Comunicación y Consentimiento Legal.',
  checkoutUrl: 'https://checkout.solucionesya.shop/cart/49815989092600:1'
}, {
  id: 'megapack',
  name: 'Megapack Protocolo + Crecimiento',
  meta: '8 tomos + 3 bonos · 110 páginas',
  price: '$34.990',
  summary: 'Todo el Kit + Primera Consulta, Educación del Paciente, Comercial y Marca Profesional.',
  checkoutUrl: 'https://checkout.solucionesya.shop/cart/49815989584120:1',
  highlight: true
}];
export function OfferSelector({
  idPrefix = 'offer'
}: {
  idPrefix?: string;
}) {
  const [selected, setSelected] = useState<OfferId>('megapack');
  const active = offers.find(o => o.id === selected)!;
  return <div className="max-w-3xl mx-auto" data-id="element-127">
      <div role="radiogroup" aria-label="Elegí tu sistema" className="flex flex-col gap-3 md:gap-4" data-id="element-128">
        {offers.map(offer => {
        const isSelected = selected === offer.id;
        return <motion.button key={offer.id} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelected(offer.id)} whileTap={{
          scale: 0.99
        }} className={`relative w-full text-left rounded-2xl p-4 md:p-5 border-2 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold flex items-center gap-4 ${isSelected ? offer.highlight ? 'bg-brand-navy border-brand-gold shadow-xl' : 'bg-white border-brand-gold shadow-lg' : 'bg-white border-slate-200 hover:border-brand-gold/50'}`} data-id="element-129">
              {/* Radio indicator */}
              <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'bg-brand-gold border-brand-gold' : 'border-slate-300'}`} data-id="element-130">
                {isSelected && <Check className="w-4 h-4 text-brand-navy" data-id="element-131" />}
              </span>

              {/* Main content */}
              <div className="min-w-0 flex-grow" data-id="element-132">
                <div className="flex items-center gap-2 flex-wrap mb-0.5" data-id="element-133">
                  <span className={`text-sm md:text-base font-bold leading-tight ${isSelected && offer.highlight ? 'text-white' : 'text-brand-navy'}`} data-id="element-134">
                    {offer.name}
                  </span>
                  {offer.highlight && <span className="bg-brand-gold text-brand-navy px-2 py-0.5 rounded-full text-[9px] md:text-[10px] font-bold flex items-center gap-1 shadow-sm whitespace-nowrap" data-id="element-135">
                      <Star className="w-2.5 h-2.5" data-id="element-136" /> MÁS ELEGIDO
                    </span>}
                </div>
                <p className={`text-[11px] md:text-xs mb-1 ${isSelected && offer.highlight ? 'text-brand-gold' : 'text-slate-500'}`} data-id="element-137">
                  {offer.meta}
                </p>
                <p className={`text-xs md:text-sm leading-snug ${isSelected && offer.highlight ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-138">
                  {offer.summary}
                </p>
              </div>

              {/* Price */}
              <div className="flex-shrink-0 text-right" data-id="element-139">
                <div className={`text-xl md:text-2xl font-bold leading-none ${isSelected && offer.highlight ? 'text-white' : 'text-brand-navy'}`} data-id="element-140">
                  {offer.price}
                </div>
                <div className="text-[10px] md:text-xs text-slate-400 mt-1" data-id="element-141">
                  ARS
                </div>
              </div>
            </motion.button>;
      })}
      </div>

      <motion.a key={active.id} href={active.checkoutUrl} whileTap={{
      scale: 0.97
    }} initial={{
      opacity: 0.6
    }} animate={{
      opacity: 1
    }} className="mt-4 md:mt-5 w-full inline-flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-goldLight text-brand-navy text-base md:text-lg font-bold rounded-lg py-4 px-6 shadow-[0_0_20px_rgba(201,162,39,0.4)] transition-colors" data-id="element-142">
        💥 QUIERO {active.id === 'megapack' ? 'EL MEGAPACK' : 'EL KIT'} ·{' '}
        {active.price}
      </motion.a>

      <p className="mt-3 flex items-center justify-center gap-2 text-xs md:text-sm text-slate-500 text-center" data-id="element-143">
        <ShieldCheck className="w-4 h-4 text-brand-gold flex-shrink-0" data-id="element-144" />
        Pago seguro · Acceso en 5 minutos · Garantía 7 días · Mercado Pago
      </p>
    </div>;
}